






















export default {
    name: 'SearchFormLayout',
    methods: {
        handleFormSubmit(e) {
            this.$emit("submit", e);
        },
    }
};
